<template>
  <div>
  <v-select
      class="custom-select"
      :clearable="false"
      label="name"
      v-model="getActiveCountry"
      :options="countries"
      @input="setSelectedCountry"
      v-if="windowWidth > 770"
  >
  </v-select>
    <select
        v-else
        class="select-one"
            id="county"
        v-model="getActiveCountry.name"
            @change="setSelectedCustomCountry($event.target.value)">
      <option
          v-for="item in countries"
          :key="item.name"
          :value="item.name"
      >{{ item.name}}</option>
    </select>
</div>
</template>

<script>
import countries from '../../../content/countries.json'
import {mapState} from 'vuex'
export default {
  name: "Select",
  data() {
    return {
      countries: countries,
      selected: null
    }
  },
  computed: {
    ...mapState({
      selectedCountry: "selectedCountry"
    }),
    getActiveCountry() {
      return this.countries.find(i => i.name === this.selectedCountry) ? this.countries.find(i => i.name === this.selectedCountry) : countries[45]
    },
    windowWidth() {
      return window.innerWidth
    }
  },
  methods: {
    setSelectedCountry(i) {
      this.$store.commit('SET_SELECTED_COUNTRY', i.name)
      // this.selected = i
      this.$gtm.trackEvent({
        event: 'lgcompromo',
        category: 'promo_map',
        eventCategory: 'promo_map',
        action: 'location',
        eventAction: 'location',
        label: i.name,
        eventLabel: i.name,
        noninteraction: false // Optional
      });
      this.$store.dispatch('getDistance', i.name)
    },
    setSelectedCustomCountry(i) {
      this.$store.commit('SET_SELECTED_COUNTRY', i)
      this.selected = i
      this.$gtm.trackEvent({
        event: 'lgcompromo',
        category: 'promo_map',
        eventCategory: 'promo_map',
        action: 'location',
        eventAction: 'location',
        label: i,
        eventLabel: i,
        noninteraction: false // Optional
      });
      this.$store.dispatch('getDistance', i)
    }
  }
}
</script>

<style lang="scss">
@import "select";
</style>